<template>
  <button @click="sendEmail">{{ $t("buttons.submit") }}</button>
</template>

<script>
export default {
  name: "HelpSendComponent",

  methods: {
    sendEmail() {
      this.$emit("save");
    },
  },
};
</script>

<style lang="scss" scoped>
button {
  background: #0990df;
  border-radius: 8px;
  padding: 6px 12px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  cursor: pointer;
  font-size: 13px;
  color: #ffffff;
  border: transparent;

  &:hover {
    background: #0990df;
  }
}
</style>
